module.exports = __webpack_public_path__ + "static/partner-3-6c123ca21e3d41dff2bd9b7b435256f6.png";